import Audiencies from './Audiencies';
import AudienciesAmp from './AudienciesAmp';
import { useAmp } from 'next/amp';

export default function Component(props) {
    const isAmp = useAmp();
    return isAmp ? <AudienciesAmp {...props} /> : <Audiencies {...props} />;
}
